import { useTranslation } from "react-i18next";
import TrafficListItem from "./TrafficListItem";

function TrafficList({ data }) {
  const { t } = useTranslation();

  if (!Array.isArray(data) || data.length === 0)
    return <p>{t("trafficMonitoring.monitoring.noDataAvailable")}</p>; // ✅ Handle empty data

  return (
    <>
      {data.map((data, index) => (
        <TrafficListItem
          key={index}
          title={data.name}
          values={data.values}
          description={data.description}
        />
      ))}
    </>
  );
}

export default TrafficList;
